<template>
  <section class="detail-aside">
    <!-- Incomplete -->
    <!-- Waiting for Adjustment Quote -->
    <div
      v-if="[401, 301].includes(form.pcy_stts)"
      class="card yellow-card child-button-block">
      <span class="label">Complete This Policy</span>
      <p class="pd-b-15">This policy is missing</p>
      <!--      <p-->
      <!--        v-for="(item,index) in tabName"-->
      <!--        :key="index"-->
      <!--        class="pd-b-15">{{item}}</p>-->
      <!-- Waiting for Adjustment Quote -->
      <template v-if="form.pcy_stts == 301">
        <v-button
          gray
          :disabled="true"
          icon="scroll">Adjustment Quote Pending</v-button>
        <v-button
          blue
          icon="eye"
          @click="onViewDocument">View and Upload Documents</v-button>
      </template>
      <!-- Incomplete -->
      <template v-if="form.pcy_stts == 401">
        <!-- <v-button
          v-if="showIssueCoverNoteBtn"
          type="info"
          :disabled="form.adjust_cvr_exist? true: false"
          :icon="form.adjust_cvr_exist? 'check': 'scroll'"
          @click="onIssueCoverNote">Issue Cover Note</v-button> -->
        <v-button
          blue
          icon="eye"
          @click="onViewDocument">View and Upload Documents</v-button>
      </template>
      <v-button
        v-if="showIssueCoverNoteBtn"
        gray
        icon="scroll"
        @click="onMakeCoverNote">Make Cover Note</v-button>
      <v-button
        v-if="form.btn_issue_with_api"
        purple
        icon="project-diagram"
        @click="onIssueApi">Issue with API</v-button>
      <v-button
        v-if="form.btn_pdf_with_api"
        purple
        icon="project-diagram"
        @click="onPcyPDFApi">Policy PDF with API</v-button>
      <v-button
        v-if="form.btn_issue_cn_with_api ==1"
        purple
        icon="project-diagram"
        @click="onIssueCNApi">Issue C/N with API</v-button>
      <v-button
        v-if="form.btn_issue_pcy_with_api==1"
        purple
        icon="project-diagram"
        @click="onIssuePcyApi">Issue Policy with API</v-button>
    </div>
    <!-- Ready For Insurer -->
    <!-- Waiting for Adjustment Quote -->
    <div
      v-if="[410, 301].includes(form.pcy_stts)"
      class="card yellow-card child-button-block">
      <span class="label">Send To Insurer</span>
      <p class="pd-b-15">This policy’s proof documents are complete.</p>
      <!-- Waiting for Adjustment Quote -->
      <template v-if="form.pcy_stts == 301">
        <v-button
          gray
          icon="download"
          :disabled="true">Adjustment Quote Pending</v-button>
        <v-button
          gray
          :disabled="true"
          icon="check">Adjustment Quote Pending</v-button>
        <v-button
          green
          :disabled="true"
          icon="shoe-prints">Adjustment Quote Pending</v-button>
        <v-button
          blue
          :disabled="true"
          icon="check-double">Adjustment Quote Pending</v-button>
      </template>
      <!-- Ready For Insurer -->
      <template v-if="form.pcy_stts == 410">
        <v-button
          v-if="form.adjust_app_form_url"
          gray
          icon="download"
          @click="onDownload">Download Application</v-button>
        <!-- <v-button
          v-if="showIssueCoverNoteBtn"
          type="info"
          :disabled="form.adjust_cvr_exist? true: false"
          :icon="form.adjust_cvr_exist? 'check': 'scroll'"
          @click="onIssueCoverNote">Issue Cover Note</v-button> -->
        <v-button
          green
          icon="shoe-prints"
          @click="onMarkAsIssuing">Mark As Issuing</v-button>
        <!-- <v-button
          type="primary"
          icon="check-double"
          @click="openDialog('issue-mark')">Issue & Mark As Issuing</v-button> -->
      </template>
      <v-button
        v-if="showIssueCoverNoteBtn"
        gray
        icon="scroll"
        @click="onMakeCoverNote">Make Cover Note</v-button>
      <v-button
        v-if="form.btn_issue_with_api"
        purple
        icon="project-diagram"
        @click="onIssueApi">Issue with API</v-button>
      <v-button
        v-if="form.btn_pdf_with_api"
        purple
        icon="project-diagram"
        @click="onPcyPDFApi">Policy PDF with API</v-button>
      <v-button
        v-if="form.btn_issue_cn_with_api ==1"
        purple
        icon="project-diagram"
        @click="onIssueCNApi">Issue C/N with API</v-button>
      <v-button
        v-if="form.btn_issue_pcy_with_api==1"
        purple
        icon="project-diagram"
        @click="onIssuePcyApi">Issue Policy with API</v-button>
    </div>
    <!-- Issuing -->
    <div
      v-if="form.pcy_stts == 420"
      class="card yellow-card child-button-block">
      <span class="label">Turn To New Policy</span>
      <p class="pd-b-15">Complete this policy once it is issued by the insurer.</p>
      <v-button
        v-if="form.adjust_app_form_url"
        gray
        icon="download"
        @click="onDownload">Download Application</v-button>
      <v-button
        v-if="issuedShow"
        green
        icon="clipboard-check"
        @click="onEnterPolicyNo">Mark As Issued</v-button>
      <v-button
        v-if="showIssueCoverNoteBtn"
        gray
        icon="scroll"
        @click="onMakeCoverNote">Make Cover Note</v-button>
      <v-button
        v-if="form.btn_issue_with_api"
        purple
        icon="project-diagram"
        @click="onIssueApi">Issue with API</v-button>
      <v-button
        v-if="form.btn_pdf_with_api"
        purple
        icon="project-diagram"
        @click="onPcyPDFApi">Policy PDF with API</v-button>
      <v-button
        v-if="form.btn_issue_cn_with_api ==1"
        purple
        icon="project-diagram"
        @click="onIssueCNApi">Issue C/N with API</v-button>
      <v-button
        v-if="form.btn_issue_pcy_with_api==1"
        purple
        icon="project-diagram"
        @click="onIssuePcyApi">Issue Policy with API</v-button>
    </div>
    <!-- dialog -->
    <v-dialog
      v-model="dialog"
      width="500px">
      <div class="dialog-container">
        <template v-if="['mark', 'issue-mark'].includes(dialogType)">
          <h3>Mark As Issuing</h3>
          <p>This policy will no longer be adjustable. Continue?</p>
        </template>
        <template v-if="dialogType == 'enterPolicyNo'">
          <h3>Enter Policy No</h3>
          <p>This policy will advance to “New Policy.”</p>
          <v-input
            v-model="pcy_no"
            placeholder="Policy No." />
        </template>
        <div class="dialog-footer">
          <v-button @click="dialog = false">Cancel</v-button>
          <v-button
            type="primary"
            @click="onContinue">Continue</v-button>
        </div>
      </div>
    </v-dialog>

    <mark-as-issuing-dialog
      ref="mark-as-issuing-dialog"
      :form="form"
      :orderId="orderId"
      :changeUploadData="coverData"
      @success="handlerMarkIssuingSuccess" />
    <sme-mark-as-issuing-dialog
      v-model="showSmeIssuing"
      :form="form"
      :orderId="orderId"
      @update="handlerMarkIssuingSuccess">

    </sme-mark-as-issuing-dialog >
    <add-official-policy
      ref="add-official-policy"
      :form="form"
      :orderId="orderId"
      :changeUploadData="officeCover"
      @success="handlerAddOfficialPolicySuccess" />
    <open-issue-pcy-dialog
      v-model="openIssuePcy"
      :form="form"
      :orderId="orderId"
      @update="handlerAddOfficialPolicySuccess" />
    <make-cover-dialog
      v-model="showCoverTime"
      :form="form"
      :orderId="orderId"
      @update="handlerAddOfficialPolicySuccess"></make-cover-dialog>
  </section>
</template>
<script>
import {mapState} from 'vuex'
import {
  issueOrderCvr,
  orderEnterPcyNo,
  orderIssueComplete,
  orderIssueIssuing,
  RebuildPDF,
  sendOrderIssueIssuingNotice
} from '@/api/order'
import {issueApi, issueCNApi, pcyPDFApi} from '@/api/policy'
import MarkAsIssuingDialog from './dialog/mark-as-issuing'
import SmeMarkAsIssuingDialog from './dialog/smeMarkAsInssuingDialog'
import AddOfficialPolicy from './dialog/add-official-policy'
import openIssuePcyDialog from './dialog/openIssuePcy'
import makeCoverDialog from './dialog/make-cover-dailog'
export default {
  name: 'DetailAside',
  components: {
    MarkAsIssuingDialog,
    AddOfficialPolicy,
    SmeMarkAsIssuingDialog,
    openIssuePcyDialog,
    makeCoverDialog
  },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    tabName: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      dialog: false,
      dialogType: '',
      pcy_no: '',
      showSmeIssuing:false,
      openIssuePcy:false,
      showCoverTime:false
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    orderId() {
      let {id} = this.$route.query
      if(this.isNewSME)
      {
        return id
      }
      return this.form.id
    },
    isNewSME() {
      let {sme_versions} = this.form||{}
      return sme_versions==3
    },
    showIssueCoverNoteBtn() {
      let {cvr_note_rebuild} = this.form||{}
      return cvr_note_rebuild == 1
    },
    isSMEProduct(){
      return this.productId >= 80
    },
    coverData(){
      let {policy_invoice} = this.form||{}
      let {record=[]} = policy_invoice||{}
      if(record.length>0)
      {
        let data = record[0].data||[]
        let cover =  data.filter(item=>(item.type=='cvr_pdf_path'))
        return cover.length>0?cover[0]:{}
      }
      else return  {}
    },
    officeCover(){
      let {policy_invoice} = this.form||{}
      let {record=[]} = policy_invoice||{}
      if(record.length>0) {
        let data = record[0].data || []
        let cover = data.filter(item => (item.type == 'pcy_pdf_path'))
        return cover.length > 0 ? cover[0] : {}
      }
      else return  {}
    },

    issuedShow(){
      let res = true
      let {tag_language = []} = this.form
      // if(this.isSMEProduct)return false
      tag_language.filter(item => {
        if([8,16,32,64].includes(item.id)){
          res = false

        }
      })
      return res
    }
  },
  methods: {
    openDialog(type) {
      this.dialogType = type
      this.dialog = true
    },
    onEnterPolicyNo() {
      this.$refs['add-official-policy'].changeDialog()
    },
    onIssueApi(){
      this.network().issueApi()
    },
    onPcyPDFApi(){
      this.network().pcyPDFApi()
    },
    onIssueCNApi(){
      this.network().issueCNApi()
    },
    onIssuePcyApi(){
      this.openIssuePcy = true
    },
    onMarkAsIssuing() {
      if(this.isSMEProduct&&!this.isNewSME){
        this.showSmeIssuing = true
      }else
        this.$refs['mark-as-issuing-dialog'].changeDialog()
    },
    onIssueCoverNote() {
      this.network().issueOrderCvr()
    },
    onMakeCoverNote() {
      this.showCoverTime = true
    },
    onViewDocument() {
      this.$emit('viewDocuments')
    },
    onDownload() {
      const { adjust_app_form_url } = this.form
      console.log(this.form)
      if(adjust_app_form_url) {
        window.open(adjust_app_form_url, '_blank')
      }
    },
    onContinue() {
      if(this.dialogType == 'mark') {
        this.network().orderIssueIssuing()
      }
      if(this.dialogType == 'issue-mark') {
        this.network().orderIssueComplete()
      }
      if(this.dialogType == 'enterPolicyNo') {
        this.network().orderEnterPcyNo()
      }
    },
    handlerMarkIssuingSuccess() {
      // this.$emit('markIssuingSuccess')
      this.$emit('update')
    },
    handlerAddOfficialPolicySuccess() {
      this.$emit('update')
    },
    network() {
      return {
        RebuildCoverPDF: async (params) => {
          const {data} = await RebuildPDF({order_id: this.orderId,type:'cvr_pdf_path'})
          const {code} = data
          // if(code === 1000){
          //   this.$message({
          //     type: 'success',
          //     message: data.message_language,
          //   })
          // }
          this.showCoverTime=true

        },
        issueOrderCvr: async () => {
          const { data } = await issueOrderCvr({
            order_id: this.orderId
          })
          this.dialog = false
          this.$emit('update')
        },
        orderIssueIssuing: async () => {
          const { data } = await orderIssueIssuing({
            order_id: this.orderId
          })
          this.dialog = false
          this.$emit('update')
        },
        orderIssueComplete: async () => {
          const { data } = await orderIssueComplete({
            order_id: this.orderId
          })
          this.dialog = false
          this.$emit('update')
        },
        orderEnterPcyNo: async () => {
          const { data } = await orderEnterPcyNo({
            order_id: this.orderId,
            pcy_no: this.pcy_no
          })
          this.dialog = false
          this.$emit('update')
        },
        issueApi: async () => {
          const {data} = await issueApi({
            order_id:  this.orderId
          })
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: data.message_language
            })
            this.$emit('update')
          }
        },
        pcyPDFApi: async () => {
          const {data} = await pcyPDFApi({
            order_id:  this.orderId
          })
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: data.message_language
            })
            this.$emit('update')
          }
        },
        issueCNApi: async () => {
          const {data} = await issueCNApi({
            order_id:  this.orderId,
            type:2
          })
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: data.message_language
            })
            this.$emit('update')
          }
        },
        sendOrderIssueIssuingNotice: async (params) => {
          const { data } = await sendOrderIssueIssuingNotice({
            order_id: this.orderId,
            content:params
          })
          this.smsDialog=false
          this.$emit('update')
          // this.dialog = false
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.detail-aside {
  .yellow-card {
    background: #fbcb15;
    border: 1px solid  #FFE000;
    border-radius: 15px;
    &:last-child{
      margin-bottom: 0!important;
    }
    .label {
      color: #723c14;
    }
    p {
      padding-bottom: 8px;
      color: #723c14;
      font-size: 14px;
    }
    .purple{
      background: #8d5de8;
      color: #fff;
      border-color: #8d5de8;
    }
  }
  .dialog-container {
    padding: 15px;
    h3 {
      padding-bottom: 10px;
    }
    p {
      padding-bottom: 10px;
    }
    .dialog-footer {
      margin: 15px -15px -15px;
      padding: 15px;
      text-align: right;
      background: #f9fafb;
    }
  }
}
</style>
